import React, { useContext, useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import { useViewerContextQuery, ViewerContext_UserFragment } from './ViewerContext.generated';

const context = React.createContext<ViewerContext_UserFragment | null>(null);

export const ViewerConsumer = context.Consumer;
export const ViewerProvider = context.Provider;

export function useViewer(): ViewerContext_UserFragment | null {
    return useContext(context);
}

interface Props {
    children: React.ReactNode;
}

export default function ViewerProviderQuery({ children }: Props) {
    const { loading, error, data } = useViewerContextQuery();

    useEffect(() => {
        if (data?.viewer) {
            Bugsnag.addMetadata('viewer', {
                userId: data.viewer.id,
            });
        } else {
            Bugsnag.addMetadata('viewer', {
                userId: null,
            });
        }
    }, [data]);

    if (loading) return null;
    if (error) throw error;
    if (!data) throw new Error('missing viewer data');

    return <context.Provider value={data.viewer}>{children}</context.Provider>;
}

type Role = 'logged-out' | 'customer' | 'designer' | 'admin';

export function viewerRole(user: ViewerContext_UserFragment | null): Role {
    if (!user) {
        return 'logged-out';
    } else if (user.isAdmin) {
        return 'admin';
    } else if (user.isDesigner) {
        return 'designer';
    } else {
        return 'customer';
    }
}
